import { ArrowUp, ArrowDown, Minus } from "lucide-react";

export const ChangeIndicator = ({ change, improved }) => {
  if (change === 0) {
    return (
      <div className="flex items-center gap-1 text-gray-500">
        <Minus className="w-4 h-4" />
        <span className="text-sm font-mono">0%</span>
      </div>
    );
  }
  
  return (
    <div className={`flex items-center gap-1 ${improved ? 'text-green-600' : 'text-red-600'}`}>
      {improved ? <ArrowUp className="w-4 h-4" /> : <ArrowDown className="w-4 h-4" />}
      <span className="text-sm font-mono font-bold">{change > 0 ? '+' : ''}{change}%</span>
    </div>
  );
};
